<template>
  <v-card
    color="grey lighten-4"
    light
  >
    <v-card-text>
      <content-section
        id="timeline"
        :title="detailed ? 'My Experiences' : 'My Experiences'"
      >
        <v-timeline
          dense
        >
          <v-timeline-item
            v-for="(item, i) in orderedItems"
            :key="i"
            :icon="item.icon || ''"
            :class="{transparent: item.transparent}"
            large
          >
            <template
              v-if="item.iconImage"
              v-slot:icon
            >
              <v-avatar>
                <img
                  :src="publicPath(item.iconImage)"
                >
              </v-avatar>
            </template>
            <template v-slot:opposite />
            <v-layout>
              <v-flex
                v-if="$vuetify.breakpoint.smAndUp"
                md1
                sm2
                align-self-center
              >
                <span>{{ item.year }}</span>
              </v-flex>
              <v-flex
                md11
                sm10
                xs12
              >
                <v-card class="elevation-1">
                  <v-card-title class="pb-0">
                    <div>
                      <p v-if="$vuetify.breakpoint.xsOnly">
                        {{ item.year }}
                      </p>
                      <h3>{{ item.title }}</h3>
                    </div>
                  </v-card-title>
                  <v-card-text>
                    <v-layout wrap>
                      <v-flex
                        :md7="!!item.image"
                        :md12="!item.image"
                        xs12
                      >
                        <div class="mr-1">
                          <span
                            v-if="item.text"
                            class="pre"
                          >{{ item.text }}</span>
                          <!-- eslint-disable vue/no-v-html -->
                          <div
                            v-else-if="item.html"
                            v-html="item.html"
                          />
                          <!-- eslint-enable vue/no-v-html -->
                        </div>
                      </v-flex>
                      <v-flex
                        v-if="item.image"
                        md5
                        xs12
                      >
                        <div
                          class="mt-2"
                        >
                          <v-carousel
                            v-if="Array.isArray(item.image)"
                            :show-arrows="false"
                            :height="325"
                          >
                            <v-carousel-item
                              v-for="(citem,ci) in item.image"
                              :key="ci"
                              :src="publicPath(citem)"
                            />
                          </v-carousel>
                          <v-img
                            v-else
                            :max-height="item.imageHeight ? item.imageHeight : ''"
                            :src="publicPath(item.image)"
                          />
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-timeline-item>
        </v-timeline>
      </content-section>
    </v-card-text>
  </v-card>
</template>

<script>
import ContentSection from '@/views/dark-template/content/Section'
export default {
  name      : 'Timeline',
  components: { ContentSection },
  data      : () => ({
    detailed: true,
    items   : [
    {
        detailed: true,
        year    : 'Aug/23 - Current',
        title   : 'StartUp: ColombiaWS',
        html    : `
        <b>Responsibility</b>: 
        <br />
Since August 2023, I have been working on my own projects, building and leading my cybersecurity company, ColombiaWS.com. During this time, I have worked on various full-stack projects.        <br />
        <b>Technology</b>: ReactJS, VueJS, TypeScript, Python, Node.js, Nuxt.js, Nust.js, Next.js, Firebase and AWS.
        `,
        icon: 'mdi-desktop-classic',
      },
      {
        detailed: true,
        year    : 'Jun/22 - Jul/23',
        title   : 'CTO (HeadDeveloper) - ANTPACK',
        html    : `
        <b>Responsibility</b>: 
        <br />
        My responsibilities as a technical leader is to carry out the assigned projects with the required team (Frontend and backend developers), I am responsible for the times, the tasks and deliver advances to the clients.
        <br />
        <b>Technology</b>: NodeJS, AWS (Cognito, Lambda, EC2, S3), PHP, ReactJS, Jira, NodeJS, Python
        `,
        icon: 'mdi-desktop-classic',
      },
      {
        detailed: true,
        year    : 'Mar/22 - May/22',
        title   : 'SENIOR DEVELOPER - ASSIST CONSULTORES',
        html    : `
        <b>Responsibility</b>: 
        <br />
        Although my time in this company was short, I was able to make some improvements to the client systems (HomeCenter) developed in .NET
        <br />
        <b>Technology</b>: Angular, .NET, RedHat OpenShift, html5, css3
        `,
        icon: 'mdi-desktop-classic',
      },
      {
        detailed: true,
        year    : 'Aug/21 - Feb/22',
        title   : 'FRONTEND DEVELOPER - IPCOM',
        html    : `
        <b>Responsibility</b>: 
        <br />
        FrontEnd Developer - VueJS - Gatsby and Strapi, my time in this company was full of many learnings, I got to know several technologies, especially Google Speech to Text.
        <br />
        <b>Technology</b>: VueJS, Gatsby (React), Strapi, html5, css3
        `,
        icon: 'mdi-desktop-classic',
      },
      {
        detailed: true,
        year    : 'Jun/16 - Dec/21',
        title   : 'FULLSTACK DEVELOPER - IndeWall - FlexBlueMarkets',
        html    : `
        <b>Responsibility</b>: 
        <br />
        Lead development team for www.indewall.com using VueJS, NUXT (SSR) and MongoDB, and AWS services such as S3 for content storage, Lead the team in various web and mobile development using VueJS, NUXT (SSR) and MongoDB
        <br />
        <b>Technology</b>: NodeJs, NuxtJs (VueJs), MongoDB, AWS (Lambda, S3)
        `,
        icon: 'mdi-desktop-classic',
      },
      {
        detailed: true,
        year    : 'Jun/16 - Dec/16',
        title   : 'FULLSTACK DEVELOPER - Personal Projects',
        html    : `
        <b>Responsibility</b>: 
        <br />
        I Wrote CiuApp, is a platform for local companies to publish and promote their products and / or services, it was created in NodeJS, MongoDB and Nuxt (VueJS Front-End)
        <br />
        <b>Technology</b>: NodeJs, NuxtJs (VueJs), MongoDB, AWS (Lambda, S3)
        `,
        icon: 'mdi-desktop-classic',
      },
      {
        detailed: true,
        year    : 'Dec/15 - Jun/16',
        title   : 'FULLSTACK DEVELOPER - Personal Projects',
        html    : `
        <b>Responsibility</b>: 
        <br />
        I developed a Texas Hold'em Poker - Multiplayer platform for personal entertainment purposes.
        <br />
        <b>Technology</b>: NodeJs, Linux, html, css
        `,
        icon: 'mdi-desktop-classic',
      },
      {
        detailed: true,
        year    : 'Jul/14 - Nov/15',
        title   : 'FULLSTACK DEVELOPER - E-Volution S.A.S',
        html    : `
        <b>Responsibility</b>: 
        <br />
        Many lessons learned from this job, specially in mobile development. I also developed for Drupal, WordPress, Joomla. Server administration and management were also part of my duties in this role.
        <br />
        <b>Technology</b>: PHP, HTML5, JavaScript, Drupal, MySQL, Joomla, WordPress, Linux, Cordova, Ionic
        `,
        icon: 'mdi-desktop-classic',
      },
      {
        detailed: true,
        year    : 'Jun/13 - Jun/14',
        title   : 'FULLSTACK DEVELOPER - ART MEDICA',
        html    : `
        <b>Responsibility</b>: 
        <br />
        Created a comprehensive patient management system using PHP (MVC - CODEIGNITER)
        <br />
        <b>Technology</b>: PHP, HTML5, JavaScript, CodeIgniter, SQL Server 
        `,
        icon: 'mdi-desktop-classic',
      },
      {
        detailed: true,
        year    : 'Sep/12 - Jun/13',
        title   : 'FULLSTACK DEVELOPER - GRUPO VIDEO BASE',
        html    : `
        <b>Responsibility</b>: 
        <br />
        Worked on a variety of very interesting project, such as Facebook game development using HTML5 and JQuery, also developed for communities in Drupal and Wordpress including modules and component for Joomla. Additional technologies used include PHP and JavaScript
        <br />
        <b>Technology</b>: PHP, HTML5, JavaScript, WordPress, Drupal, Joomla! 
        `,
        icon: 'mdi-desktop-classic',
      },
      {
        detailed: true,
        year    : 'Dec/12 - Sep/12',
        title   : 'FRONTEND DEVELOPER - Linden Colombia',
        html    : `
        <b>Responsibility</b>: 
        <br />
        Large part of my development was in ActionScript 3 for didactic games to teach mathematics in several schools across the United States. The most interesting challenge I faced here was the development of a website using a completely new language: Coldfusion.
        <br />
        <b>Technology</b>: ActionScript 3, ColdFusion, HTML5, CSS
        `,
        icon: 'mdi-desktop-classic',
      },
      {
        detailed: true,
        year    : 'Dec/09 - Dec/12',
        title   : 'FULLSTACK DEVELOPER - Alcaldía de Medellín - Universidad EAFIT',
        html    : `
        <b>Responsibility</b>: 
        <br />
        Created a UDP - GPRS communications system to obtain the data from a network of strategically installed pluviographs for an early warning system. The robust backend communication system consisted of (Sockets programmed with C and PHP) with a GPRS modem configured with Linux from the serial port. The Frontend side was a google map widget that showed the exact point where the pluviograph was and the activities reported by it (rain, relative humidity, wind speed, etc).
        <br />
        <b>Technology</b>: PHP, C, HTML, CSS, JavaScript, Linux, Google Maps.
        <br />
        URL: <b>www.siata.gov.co</b>
        `,
        icon: 'mdi-desktop-classic',
      },
      {
        detailed: true,
        year    : 'Apr/07 - Dec/09',
        title   : 'FRONTEND DEVELOPER - SWA COLOMBIA S.A.S',
        html    : `
        <b>Responsibility</b>: 
        <br />
        Web development for intranet and public facing sites including mailing applications and web pages for the Medellin lottery website.
        <br />
        <b>Technology</b>: PHP, HTML, CSS, JavaScript, Linux`,
        icon: 'mdi-desktop-classic',
      },
      {
        detailed: true,
        year    : 'Jan/06 - Dec/09',
        title   : 'Teacher - Instituto ASYS',
        html    : `
        <b>Responsibility</b>: 
        <br />
        Loved being a teacher over a 3 year period.
        <br />
        <b>Technology</b>: Internet and new technologies - Free Software (Linux) - Programming I (Logic, Algorithms), Intranet (PHP) - Programming II - Visual Basic.`,
        icon: 'mdi-desktop-classic',
      },

    ],
  }),
  computed: {
    orderedItems () {
      const items = [...this.items].reverse()
      if (this.detailed)
        return items
      return items.filter((item) => {
        return !item.detailed
      })
    },
  },
}
</script>

<style scoped>
.title {
  border-bottom: 2px #bfbfbf solid;
  line-height: 1.5 !important;
}
.pre {
  white-space: pre;
}
.transparent{
  opacity: 0.6;
}
</style>
